"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var Link_1 = __importDefault(require("../Link"));
var Text_1 = __importDefault(require("../Text"));
var LinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            fontSize: theme.fontSizes[2],
            fontWeight: 'normal',
            letterSpacing: 'normal',
            lineHeight: 'normal',
            alignItems: 'center'
        },
        _b[theme.mediaQueries.md] = {
            alignItems: 'stretch'
        },
        _b);
});
var LinkItem = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            width: 'fit-content'
        },
        _b[theme.mediaQueries.md] = {
            flexWrap: 'wrap',
            height: '200px',
            width: 'auto'
        },
        _b);
});
var StyledLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.space[3],
        width: 'fit-content',
        '&:hover': {
            textDecoration: 'underline'
        }
    });
});
var SectionTitle = (0, styled_1.default)(Text_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.space[3],
        fontSize: '18px',
        fontWeight: 'bold'
    });
});
function LinkSection(props) {
    var sectionTitle = props.sectionTitle, links = props.links;
    return (react_1.default.createElement(LinkContainer, null,
        react_1.default.createElement(SectionTitle, { display: { _: 'none', md: 'block' } }, sectionTitle),
        react_1.default.createElement(LinkItem, null,
            react_1.default.createElement(SectionTitle, { display: { _: 'block', md: 'none' } }, sectionTitle), links === null || links === void 0 ? void 0 :
            links.map(function (link) {
                return react_1.default.createElement(StyledLink, { key: link.url, href: link.url, "data-event-location": "footer_menu", "data-event-label": link.label }, link.label);
            }))));
}
exports.default = LinkSection;
